import { AbstractControl } from '@angular/forms';

export const multiple = (value: number, equals?: number) => {
  return (control: AbstractControl) => {
    const { value: controlValue } = control;

    if (controlValue % value === 0) return null;
    if (equals !== undefined && controlValue === equals) return null;

    return {
      length: { message: `O campo deve conter um número múltiplo de ${value}` },
    };
  };
};
